import React from 'react';
import { useTranslation } from 'react-i18next';

interface Step {
  title: string;
  text: string;
}

const IMAGES = ['/uploads/fig/step1.jpg', '/uploads/fig/step2.jpg', '/uploads/fig/step3.jpg'];

const HowToPlantSection: React.FC = () => {
  const { t } = useTranslation();
  const steps = (t('how.steps', { returnObjects: true }) as Step[]) || [];

  return (
    <section style={{ background: '#DFEFCB', padding: '16px 24px 64px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 14 }}>
          <span className="section-tag">{t('how.tag', 'Три простых шага')}</span>
        </div>
        <h2 className="h2-center" style={{ marginBottom: 38 }}>
          {t('how.title')}
        </h2>
        <div className="grid-3" style={{ gap: 10 }}>
          {steps.map((s, i) => (
            <div
              key={i}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 16,
                background: '#fff',
                borderRadius: 20,
                padding: 16,
                boxShadow: '0 4px 16px rgba(45,80,22,.06)'
              }}
            >
              <div style={{ position: 'relative', flexShrink: 0 }}>
                <img
                  src={IMAGES[i]}
                  alt=""
                  style={{
                    width: 92,
                    height: 92,
                    borderRadius: '50%',
                    objectFit: 'cover',
                    boxShadow: '0 6px 16px rgba(45,80,22,.15)'
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: -4,
                    left: -4,
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    background: '#5EA82E',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    font: "700 14px 'Montserrat Alternates', sans-serif",
                    boxShadow: '0 4px 10px rgba(133,208,45,.5)'
                  }}
                >
                  {i + 1}
                </div>
              </div>
              <div style={{ minWidth: 0, flex: 1 }}>
                <div
                  style={{
                    font: "600 16px 'Golos Text', sans-serif",
                    color: '#2D5016'
                  }}
                >
                  {s.title}
                </div>
                <div
                  style={{
                    font: "400 13.5px/1.5 'Golos Text', sans-serif",
                    color: '#5a6b4d',
                    marginTop: 6
                  }}
                >
                  {s.text}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToPlantSection;
